<template>
  <div>
    <el-dialog
      title="编辑"
      :visible.sync="showDialog"
      custom-class="mobile-form-dialog"
      :close-on-click-modal="false"
      :before-close="beforeClose"
    >
      <el-alert
        v-if="formObj.configId"
        class="config-id-alert"
        title="本赛事已开启配置文件,部分赛事信息已根据配置文件ID替换显示,如需修改,请修改配置文件ID源信息或取消configId并重新添加报名表单"
        type="warning"
        show-icon>
      </el-alert>
      <event-form :formObj="formObj" :type="type" @edit-success="editSuccess"></event-form>
    </el-dialog>
  </div>
</template>

<script>
import EventForm from '../../components/eventForm'

export default {
  components: {
    EventForm
  },
  props: {
    formObj: {
      type:Object,
      default: () => ({})
    },
    editDialogVisible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'add'
    }
  },
  data() {
    return {
      showDialog: false
    }
  },
  watch: {
    editDialogVisible(val) {
      this.showDialog = val
    }
  },
  methods: {
    beforeClose() {
      this.$emit('close')
    },
    editSuccess() {
      this.showDialog = false
      this.$emit('edit-success')
      this.beforeClose()
    }
  }
}
</script>

<style scoped>
  .config-id-alert {
    margin-bottom: 10px;
  }
</style>
